// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';
import { ProductCard } from '../../../components/NewCard/types';
import { PaginationListResponse, SearchCondition } from '../../../types/Model';

export interface SearchLabsRequestPayload {
  limit: number;
  page: number;
  condition: SearchCondition;
}

export type SearchLabsSuccessPayload = PaginationListResponse<ProductCard>;

export interface SearchLabsFailPayload {
  error: Error;
}

export const searchLabsActions = createAsyncAction(
  'elearning/SEARCH_LABS',
  'elearning/SEARCH_LABS_SUCCESS',
  'elearning/SEARCH_LABS_FAIL'
)<
  SearchLabsRequestPayload,
  SearchLabsSuccessPayload,
  SearchLabsFailPayload
>();
